// Brittle: the dashboard endpoint (#160871) keys the count KPIs as RepeatOffenders/MSI/UnaccountedKm,
// while the search endpoint (#161109) and KpiOptions (#160873) key them D7/D8/D9. There is no shared
// identifier between the two and the array orders differ, so the count series is mapped to its D-code
// by hand here. Remove this once #160871 exposes the count KPIs under their D-codes.
export const COUNT_KPI_KEY_TO_CODE = {
    RepeatOffenders: "D7",
    UnaccountedKm: "D8",
    MSI: "D9"
};
